var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, from } from 'rxjs';
import { URL_BFM_SESSION_CREATE, BFM_CREDENTIALS, MOCK_STATUS, MOCK_URL_SESSION, MOCK_URL_EXTEND_SESSION, URL_SESSION_RESET, URL_SESSION_SIGNOUT, URL_SESSION_EXTEND, URL_LOGIN, SESSION_VAR_KEY_SESSION } from '@ibe.config';
import { INDRAStorageService } from './storage.indra.service';
import { INDRACookieService } from './cookie.indra.service';
import { Store } from '@ngrx/store';
import * as UserActions from '@ibe/store/actions/user.actions';
import * as OptionsBarActions from '@ibe/store/actions/options-bar.actions';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./storage.indra.service";
import * as i3 from "./cookie.indra.service";
import * as i4 from "@ngrx/store";
var RETRY_ON_401 = true;
var DO_NOT_RETRY_ON_401 = false;
var INDRAApiService = /** @class */ (function () {
    function INDRAApiService(http, storage, cookieService, store, storageService) {
        this.http = http;
        this.storage = storage;
        this.cookieService = cookieService;
        this.store = store;
        this.storageService = storageService;
        this.creatingSession = false;
        this.ongoingRequest = false;
        this.token = new BehaviorSubject(null);
        this.hasToken = new BehaviorSubject(false);
    }
    INDRAApiService.prototype.INDRA_getToken = function () {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            _this.token.subscribe(function (token) {
                if (token) {
                    resolve(token);
                }
                else {
                    _this.INDRA_createSessionBfm();
                }
            });
        });
        return from(promise);
    };
    INDRAApiService.prototype.INDRA_createSessionBfm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokenStored, marketCode, languageCode, urlParams, idOperation, response, currentUrl, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.creatingSession) return [3 /*break*/, 7];
                        tokenStored = this.storage.get(SESSION_VAR_KEY_SESSION);
                        if (tokenStored != null) {
                            return [2 /*return*/, this.token.next(tokenStored)];
                        }
                        this.creatingSession = true;
                        this.ongoingRequest = true;
                        marketCode = sessionStorage.getItem('market');
                        if (marketCode)
                            BFM_CREDENTIALS.market = marketCode;
                        languageCode = sessionStorage.getItem('language');
                        if (languageCode)
                            BFM_CREDENTIALS.language = languageCode;
                        urlParams = new URLSearchParams(window.location.search);
                        idOperation = urlParams.get('idOperation');
                        if (idOperation && idOperation.length)
                            BFM_CREDENTIALS.idOperation = idOperation;
                        if (!MOCK_STATUS.SESSION) return [3 /*break*/, 1];
                        this.http.get(MOCK_URL_SESSION).subscribe(function (response) {
                            _this.token.next(response['id']);
                            _this.storage.set(SESSION_VAR_KEY_SESSION, response['id']);
                        });
                        return [3 /*break*/, 7];
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, this.http.post(URL_BFM_SESSION_CREATE, BFM_CREDENTIALS).toPromise()];
                    case 2:
                        response = _a.sent();
                        if (!response) return [3 /*break*/, 5];
                        this.token.next(response['id']);
                        this.storage.set(SESSION_VAR_KEY_SESSION, response['id']);
                        sessionStorage.setItem('cookieExist', response['cookieExist'] ? 'true' : 'false');
                        currentUrl = window.location.href;
                        if (!(!currentUrl.includes('/deeplink') && response['cookieExist'])) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.INDRA_loginCookie()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (response) {
                            this.hasToken.next(true);
                        }
                        this.ongoingRequest = false;
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_1 = _a.sent();
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    INDRAApiService.prototype.executeGet = function (url, resolve, reject, retryOnError) {
        var _this = this;
        if (retryOnError === void 0) { retryOnError = false; }
        this.INDRA_getToken().subscribe(function (token) {
            var headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
            _this.http.get(url, { headers: headers }).subscribe(function (response) {
                resolve(response);
            }, function (error) {
                if (error && error.status === 401) {
                    _this.clearSessionToken();
                    if (retryOnError) {
                        return _this.executeGet(url, resolve, reject, DO_NOT_RETRY_ON_401);
                    }
                }
                reject(error);
            });
        });
    };
    INDRAApiService.prototype.clearSessionToken = function () {
        this.storage.remove(SESSION_VAR_KEY_SESSION);
        this.token.next(null);
        this.hasToken.next(false);
    };
    INDRAApiService.prototype.INDRA_get = function (url) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            _this.executeGet(url, resolve, reject, RETRY_ON_401);
        });
        return from(promise);
    };
    INDRAApiService.prototype.executePost = function (url, data, resolve, reject, retryOnError) {
        var _this = this;
        if (retryOnError === void 0) { retryOnError = false; }
        this.INDRA_getToken().subscribe(function (token) {
            var headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
            _this.http.post(url, data, { headers: headers }).subscribe(function (response) {
                resolve(response);
            }, function (error) {
                if (error && error.status === 401) {
                    _this.clearSessionToken();
                    if (retryOnError) {
                        return _this.executePost(url, data, resolve, reject, DO_NOT_RETRY_ON_401);
                    }
                }
                reject(error);
            });
        });
    };
    INDRAApiService.prototype.executePostWithFullHttpResponse = function (url, data, resolve, reject, retryOnError) {
        var _this = this;
        if (retryOnError === void 0) { retryOnError = false; }
        this.INDRA_getToken().subscribe(function (token) {
            var headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
            _this.http.post(url, data, { headers: headers, observe: 'response' }).subscribe(function (response) {
                resolve(response);
            }, function (error) {
                if (error && error.status === 401) {
                    _this.clearSessionToken();
                    if (retryOnError) {
                        return _this.executePostWithFullHttpResponse(url, data, resolve, reject, DO_NOT_RETRY_ON_401);
                    }
                }
                reject(error);
            });
        });
    };
    INDRAApiService.prototype.INDRA_post = function (url, data) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            _this.executePost(url, data, resolve, reject, RETRY_ON_401);
        });
        return from(promise);
    };
    INDRAApiService.prototype.INDRA_postFullHttpResponse = function (url, data) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            _this.executePostWithFullHttpResponse(url, data, resolve, reject, RETRY_ON_401);
        });
        return from(promise);
    };
    INDRAApiService.prototype.executeDelete = function (url, data, resolve, reject, retryOnError) {
        var _this = this;
        if (retryOnError === void 0) { retryOnError = false; }
        this.INDRA_getToken().subscribe(function (token) {
            var headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
            _this.http.request('DELETE', url, { headers: headers, body: data }).subscribe(function (response) {
                resolve(response);
            }, function (error) {
                if (error && error.status === 401) {
                    _this.clearSessionToken();
                    if (retryOnError) {
                        return _this.executeDelete(url, data, resolve, reject, DO_NOT_RETRY_ON_401);
                    }
                }
                reject(error);
            });
        });
    };
    INDRAApiService.prototype.INDRA_delete = function (url, data) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            _this.executeDelete(url, data, resolve, reject, RETRY_ON_401);
        });
        return from(promise);
    };
    INDRAApiService.prototype.INDRA_put = function (url, data) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            _this.executePut(url, data, resolve, reject, RETRY_ON_401);
        });
        return from(promise);
    };
    INDRAApiService.prototype.executePut = function (url, data, resolve, reject, retryOnError) {
        var _this = this;
        if (retryOnError === void 0) { retryOnError = false; }
        this.INDRA_getToken().subscribe(function (token) {
            var headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
            _this.http.put(url, data, { headers: headers }).subscribe(function (response) {
                resolve(response);
            }, function (error) {
                if (error && error.status === 401) {
                    _this.clearSessionToken();
                    if (retryOnError) {
                        return _this.executePut(url, data, resolve, reject, DO_NOT_RETRY_ON_401);
                    }
                }
                reject(error);
            });
        });
    };
    INDRAApiService.prototype.INDRA_createNewSession = function () {
        this.clearSessionToken();
        this.creatingSession = false;
        this.INDRA_createSessionBfm();
    };
    INDRAApiService.prototype.INDRA_extendSession = function () {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            _this.INDRA_getToken().subscribe(function (token) {
                var headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
                if (MOCK_STATUS.SESSION) {
                    _this.http.post(MOCK_URL_EXTEND_SESSION, {}, { headers: headers }).subscribe(function (response) {
                        resolve(response);
                    });
                }
                else {
                    _this.http.post(URL_SESSION_EXTEND, {}, { headers: headers }).subscribe(function (response) {
                        resolve(response);
                    }, function (error) {
                        if (error && error.status === 401) {
                            _this.clearSessionToken();
                        }
                        reject(error);
                    });
                }
            });
        });
        return from(promise);
    };
    INDRAApiService.prototype.INDRA_retrieveNewToken = function () {
        if (!this.ongoingRequest) {
            this.clearSessionToken();
            this.creatingSession = false;
        }
        return this.INDRA_getToken();
    };
    /** note: used to reset values/objects stored in the backend ( resets and renews the session itself ) **/
    INDRAApiService.prototype.resetSessionValues = function () {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            var marketCode = sessionStorage.getItem('market');
            if (marketCode)
                BFM_CREDENTIALS.market = marketCode;
            var languageCode = sessionStorage.getItem('language');
            if (languageCode)
                BFM_CREDENTIALS.language = languageCode;
            _this.INDRA_post(URL_SESSION_RESET, BFM_CREDENTIALS).subscribe(function (res) { return __awaiter(_this, void 0, void 0, function () {
                var currentUrl;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.token.next(res['id']);
                            this.storage.set(SESSION_VAR_KEY_SESSION, res['id']);
                            sessionStorage.setItem('cookieExist', res['cookieExist'] ? 'true' : 'false');
                            currentUrl = window.location.href;
                            if (!(!currentUrl.includes('/deeplink') && res['cookieExist'])) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.INDRA_loginCookie()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (res) {
                                this.hasToken.next(true);
                            }
                            this.ongoingRequest = false;
                            resolve(res);
                            return [2 /*return*/];
                    }
                });
            }); }, function (error) {
                reject(null);
            });
        });
        return from(promise);
    };
    INDRAApiService.prototype.INDRA_signOutFromSession = function () {
        return this.INDRA_post(URL_SESSION_SIGNOUT, {});
    };
    INDRAApiService.prototype.INDRA_automaticLogin = function (loginRequest) {
        return this.INDRA_post(URL_LOGIN, loginRequest);
    };
    INDRAApiService.prototype.INDRA_loginCookie = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, _a, userProfile, userPnrs, translate, userAddress, defaultCurrency, userData, userInfo, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.INDRA_loginCookieAPI().toPromise()];
                    case 1:
                        response = _b.sent();
                        if (response && response.data && response.errors.length === 0) {
                            _a = response.data, userProfile = _a.userProfile, userPnrs = _a.userPnrs, translate = _a.translate, userAddress = _a.userAddress, defaultCurrency = _a.defaultCurrency;
                            userData = __assign({}, userProfile, { userPnrs: userPnrs, userAddress: userAddress, translate: translate, userProfile: userProfile, defaultCurrency: defaultCurrency });
                            this.storage.set('userData', userData);
                            userInfo = __assign({}, userProfile, { defaultCurrency: defaultCurrency });
                            this.store.dispatch(new UserActions.PutLoggedInAction(true));
                            this.store.dispatch(new UserActions.PutUserInfoAction(userInfo));
                            this.store.dispatch(new UserActions.PutUserPNRSAction(userPnrs));
                            if (this.cookieService.isAward) {
                                this.store.dispatch(new OptionsBarActions.PutPriceUnit('miles'));
                                this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(true));
                            }
                        }
                        else {
                            this.INDRA_clearUserInfo();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _b.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    INDRAApiService.prototype.INDRA_loginCookieAPI = function () {
        return this.INDRA_post(URL_LOGIN, {});
    };
    INDRAApiService.prototype.INDRA_clearUserInfo = function () {
        this.store.dispatch(new UserActions.PutLoggedInAction(false));
        this.store.dispatch(new UserActions.PutUserInfoAction(false));
        this.store.dispatch(new UserActions.PutCancelLogIn(false));
        this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
        this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(false));
        this.storageService.remove('userData');
        this.storageService.remove('user_info');
        this.storageService.remove('prevSelectedLanguage');
    };
    INDRAApiService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAApiService_Factory() { return new INDRAApiService(i0.inject(i1.HttpClient), i0.inject(i2.INDRAStorageService), i0.inject(i3.INDRACookieService), i0.inject(i4.Store), i0.inject(i2.INDRAStorageService)); }, token: INDRAApiService, providedIn: "root" });
    return INDRAApiService;
}());
export { INDRAApiService };
